const state = {
  onlinetest: [],
  onlinetest_id: [],
};

export default state;
